<template>
  <main>
    <v-container class="grey lighten-4 fill-height">
      <v-row>
            <v-col class="mx-auto" >
              <v-card class="elevation-12 ma-3">
                  <v-toolbar
                  color="primary"
                  dark
                  flat>
                  <v-toolbar-title>Översikt</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
    <v-row>
    <v-card class="mr-5"
  >
    <v-card-text>
      <h1 class="text-center">{{schedule.schedule}}</h1>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        text
        class="themecolor"
        to="/account/schedules"
      >
        Scheman
      </v-btn>
    </v-card-actions>
  </v-card>
  <v-card
  >
    <v-card-text >
      <h1 class="text-center">{{schedule.comments}}</h1>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        text
        class="themecolor"
        to="/account/comments"
      >
        Kommentarer
      </v-btn>
    </v-card-actions>
  </v-card>
  </v-row>
  <v-row>
  <h2 class="mt-5">Schemalägg ett möte</h2>
   </v-row>
  <v-row>
  <p>Planerar du ett möte med vänner eller kollegor? Vårt verktyg kommer att vara en stor hjälp både för dig och för alla som deltar.</p>
  
  </v-row>
  <v-row>
  <v-btn
        color="success"
        text
        class="themecolor"
        to="/"
      >
        Schemalägg ett möte
      </v-btn>
       </v-row>
                </v-card-text>
            </v-card>
            </v-col> 
        </v-row>
    </v-container>
  </main>
</template>

<script>
import axios from "axios";
import store from "../../store";
export default {
  name: "Dashboard",
  created: async function() {
    if (!this.store.state.isLoggedIn) this.$router.replace("/login");
    if (this.store.state.user.role == "admin")
      this.$router.replace("/admin/dashboard");
      var config = {
            method: "get",
            url: `${this.store.state.baseURL}schedulecount/${this.store.state.user.id}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        let resp = await axios(config);
        this.schedule = resp.data;
  },
  data: () => ({
    isLoggedIn: null,
    store: store,
    schedule: '',
  }),
  methods: {
    reloadPage() {
      window.location.reload();
    },
  },
};
</script>
<style>
.themecolor {
  color:#ffa500 !important;
}
</style>